import * as actionTypes from '../../../constants/ActionTypes/CSAgentPortal/CustomerDashboard';

const initialState = {
    emailLogs: {},
    loading: false,
    error: true,
    success:false
}

const FetchEmailLogs = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_EMAIL_LOGS:
            return {
                ...state,
                loading: true,
                success: false,
                error: false
            }
        
        case actionTypes.FETCH_EMAIL_LOGS_SUCCESS:
            return {
                ...state,
                success: true,
                emailLogs: action.emailLogs,
                loading: false
            }
        
        case actionTypes.FETCH_EMAIL_LOGS_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.message
            }
        default:
            return {...state}
    }
}

export default FetchEmailLogs